export const contentMaxWidth = '1200px';
export const contentMinWidth = '800px';